import i18n from "i18next";

export enum LevelBadge {
  sprout,
  leaf,
  flowerBud,
  flower,
  tree,
  mountainRange,
  galaxy,
}

export function makeLevelBadgeFrom(termCount: number): LevelBadge {
  switch (true) {
    case termCount < 51:
      return LevelBadge.sprout;
    case termCount >= 51 && termCount <= 200:
      return LevelBadge.leaf;
    case termCount >= 201 && termCount <= 500:
      return LevelBadge.flowerBud;
    case termCount >= 501 && termCount <= 1000:
      return LevelBadge.flower;
    case termCount >= 1001 && termCount <= 2000:
      return LevelBadge.tree;
    case termCount >= 2001 && termCount <= 5000:
      return LevelBadge.mountainRange;
    default:
      return LevelBadge.galaxy;
  }
}

export function getLevelText(levelBadge: LevelBadge): string {
  switch (levelBadge) {
    case LevelBadge.sprout:
      return i18n.t("TermCountLevelSprout");
    case LevelBadge.leaf:
      return i18n.t("TermCountLevelLeaf");
    case LevelBadge.flowerBud:
      return i18n.t("TermCountLevelFlowerBud");
    case LevelBadge.flower:
      return i18n.t("TermCountLevelFlower");
    case LevelBadge.tree:
      return i18n.t("TermCountLevelTree");
    case LevelBadge.mountainRange:
      return i18n.t("TermCountLevelMountainRange");
    case LevelBadge.galaxy:
      return i18n.t("TermCountLevelGalaxy");
  }
}

export function getLevelEmoji(levelBadge: LevelBadge): string {
  switch (levelBadge) {
    case LevelBadge.sprout:
      return "🌱";
    case LevelBadge.leaf:
      return "🌿";
    case LevelBadge.flowerBud:
      return "🌷";
    case LevelBadge.flower:
      return "🌼";
    case LevelBadge.tree:
      return "🌳";
    case LevelBadge.mountainRange:
      return "🌄";
    case LevelBadge.galaxy:
      return "🌌";
  }
}
